"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatCurrencyByLanguageTag = exports.currencyFormats = void 0;
const currency_js_1 = __importDefault(require("currency.js"));
exports.currencyFormats = {
    default: (value, precision) => 
    // $123,987.50
    currency_js_1.default(value, { precision }),
    'fr-CA': (value, precision) => 
    // 123 987,50 $
    currency_js_1.default(value, {
        symbol: '$',
        decimal: ',',
        separator: ' ',
        pattern: `# !`,
        negativePattern: `-# !`,
        precision,
    }),
    'fr-US': (value, precision) => 
    // 123 987,50 $
    currency_js_1.default(value, {
        symbol: '$',
        decimal: ',',
        separator: ' ',
        pattern: `# !`,
        negativePattern: `-# !`,
        precision,
    }),
};
/**
 * Formats a number into currency by language/country using curreny.js.
 * @param {string|number|currency|null|undefined} toFormat - format into currency
 * @param {string} languageTag - a language tag. defaults to 'en-US'
 * @param {number} precision - number of digits after the decimal
 * @return {string} - formatted currency, fr-CA: 123 456,78$ default: $123,456.78
 */
const formatCurrencyByLanguageTag = (toFormat, languageTag, precision = 2) => {
    if (typeof exports.currencyFormats[languageTag] === 'function') {
        return exports.currencyFormats[languageTag](currency_js_1.default(toFormat), precision).format();
    }
    return exports.currencyFormats['default'](currency_js_1.default(toFormat), precision).format();
};
exports.formatCurrencyByLanguageTag = formatCurrencyByLanguageTag;
